// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReDate from "@mobily/rescript-date/src/ReDate.bs.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as App_Button$DvmAdminFrontendFr from "../../../common/components/button/App_Button.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../common/utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../common/App_Typography.bs.js";
import * as Messages_Button$DvmAdminFrontendFr from "../../../intl/messages/Messages_Button.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../common/types/App_Types_Result.bs.js";
import * as Pool_Expenses_Api$DvmAdminFrontendFr from "../../poolExpenses/Pool_Expenses_Api.bs.js";
import * as App_OverlaySpinner$DvmAdminFrontendFr from "../../../common/components/App_OverlaySpinner.bs.js";
import * as Messages_Bonuses_Manage$DvmAdminFrontendFr from "../../../intl/messages/bonuses/Messages_Bonuses_Manage.bs.js";

function getPeriodFromDate(date) {
  return Belt_Option.flatMap(date, (function (x) {
                var monthNum = ReDate.getMonth(x);
                var match = monthNum / 3 | 0;
                switch (match) {
                  case 0 :
                      return "JFM";
                  case 1 :
                      return "AMJ";
                  case 2 :
                      return "JAS";
                  case 3 :
                      return "OND";
                  default:
                    return ;
                }
              }));
}

function Bonuses_Manage_Validate(Props) {
  var manageCall = Props.manageCall;
  var rows = Props.rows;
  var intl = ReactIntl.useIntl();
  var alert = ReactAlert.useAlert();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setResult = match$2[1];
  var result = match$2[0];
  var match$3 = React.useState(function () {
        
      });
  var setIsOutOfResources = match$3[1];
  var isOutOfResources = match$3[0];
  var match$4 = React.useState(function () {
        
      });
  var setPoolAmount = match$4[1];
  var poolAmount = match$4[0];
  React.useEffect((function () {
          Belt_Option.mapWithDefault(Belt_List.get(rows, 0), undefined, (function (x) {
                  if (Belt_Option.getWithDefault(x.requestType, "") !== "POOL") {
                    return ;
                  }
                  Curry._1(setPoolAmount, (function (param) {
                          return x.actualAmount;
                        }));
                  var match = x.mr;
                  var match$1 = Belt_Option.flatMap(x.orderDate, (function (x) {
                          return ReDate.getYear(x);
                        }));
                  var match$2 = getPeriodFromDate(x.orderDate);
                  if (match !== undefined && match$1 !== undefined && match$2 !== undefined) {
                    return Pool_Expenses_Api$DvmAdminFrontendFr.fetchPoolExpenses(undefined, userManager, setResult, "?limit=1&offset=0&filter=mr=" + match + ";year=" + String(match$1) + ";periodID=" + match$2 + "", selectedRole, /* MR */1);
                  }
                  
                }));
        }), []);
  React.useEffect((function () {
          if (typeof result === "number") {
            result === /* NotStarted */0;
          } else if (result.TAG === /* Ok */0) {
            var mrTable = result._0;
            Curry._1(setIsOutOfResources, (function (param) {
                    return Belt_Option.mapWithDefault(Belt_List.get(mrTable.content, 0), 0, (function (x) {
                                  return Belt_Option.getWithDefault(x.remainingResources, 0);
                                })) < Belt_Option.getWithDefault(poolAmount, 0);
                  }));
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: result._0
                      }
                    }));
          }
        }), [result]);
  return React.createElement(App_OverlaySpinner$DvmAdminFrontendFr.make, {
              show: App_Types_Result$DvmAdminFrontendFr.isPending(result),
              children: React.createElement(Core.Grid, {
                    children: null,
                    container: true,
                    direction: "column",
                    spacing: 1
                  }, React.createElement(Core.Grid, {
                        children: null,
                        container: true,
                        item: true,
                        justifyContent: "space-between"
                      }, React.createElement(Core.Grid, {
                            children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                  style: {
                                    fontWeight: "bold"
                                  },
                                  children: intl.formatMessage(Messages_Bonuses_Manage$DvmAdminFrontendFr.validationConfirmation),
                                  variant: "bodyBig"
                                }),
                            item: true
                          }), React.createElement(Core.Grid, {
                            children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                  onClick: (function (param) {
                                      Curry._3(manageCall, /* Validate */0, undefined, undefined);
                                    }),
                                  label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.confirm),
                                  size: "medium",
                                  disabled: Belt_Option.getWithDefault(isOutOfResources, false) || App_Types_Result$DvmAdminFrontendFr.isError(result)
                                }),
                            item: true
                          })), Belt_Option.mapWithDefault(isOutOfResources, null, (function (x) {
                          if (x) {
                            return React.createElement(Core.Grid, {
                                        children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                              color: "error",
                                              style: {
                                                fontWeight: "bold",
                                                maxWidth: "500px"
                                              },
                                              children: intl.formatMessage(selectedRole === /* MRR */8 ? Messages_Bonuses_Manage$DvmAdminFrontendFr.mrWarningNoMoreResources : Messages_Bonuses_Manage$DvmAdminFrontendFr.adminsWarningNoMoreResources),
                                              variant: "bodyBig"
                                            }),
                                        item: true
                                      });
                          } else {
                            return null;
                          }
                        })))
            });
}

var Types;

var make = Bonuses_Manage_Validate;

export {
  Types ,
  getPeriodFromDate ,
  make ,
}
/* react Not a pure module */
